import { LegacyLinkPage } from "@/views/legacy-link/legacy-link-page";

/*
 * This component used to be the entry point to job opening, hence the custom 404 page. Should this custom page become default 404 this file and one-off component can both be removed.
 */
function PublicJobPage() {
  return <LegacyLinkPage />;
}

export default PublicJobPage;
